import { useCallback, useState } from 'react';

type NotificationType = 'success' | 'warning' | 'error';

interface Notification {
  text: string;
  type: NotificationType;
}

const TYPE_COLORS: Record<NotificationType, string> = {
  success: 'var(--accent)',
  warning: 'var(--warning)',
  error: 'var(--danger)',
};

interface UseNotificationOptions {
  /** Duration in ms before auto-dismiss. Default: 2500 */
  duration?: number;
  /** Distance from bottom in px. Default: 80 */
  bottom?: number;
}

export function useNotification(options?: UseNotificationOptions) {
  const [notification, setNotification] = useState<Notification | null>(null);
  const duration = options?.duration ?? 2500;
  const bottom = options?.bottom ?? 80;

  const notify = useCallback(
    (text: string, type: NotificationType = 'success') => {
      setNotification({ text, type });
      setTimeout(() => setNotification(null), duration);
    },
    [duration]
  );

  const NotificationToast = notification ? (
    <div
      style={{
        position: 'fixed',
        bottom,
        left: '50%',
        transform: 'translateX(-50%)',
        padding: '8px 16px',
        borderRadius: 'var(--radius)',
        background: TYPE_COLORS[notification.type],
        color: '#fff',
        fontSize: 12,
        fontWeight: 600,
        fontFamily: 'var(--font-mono)',
        zIndex: 200,
        boxShadow: 'var(--shadow-elevated)',
      }}
    >
      {notification.text}
    </div>
  ) : null;

  return { notify, NotificationToast };
}
